import React from "react";
import { Grid, Typography, Link } from "@mui/material";
import { useTranslation } from "react-i18next";

const GoogleReCaptchaText = () => {
  const { t } = useTranslation();
  return (
    <Grid container justifyContent="center">
      <Grid item style={{ paddingTop: 15, paddingBottom: 15, width: 320 }}>
        <Typography variant="body2" color="textSecondary" align="center">
          {t("registration.GoogleText1")}
          <Link
            style={{ color: "#47a3f2" }}
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("registration.GoogleLink1")}
          </Link>
          {t("registration.GoogleText2")}
          <Link
            style={{ color: "#47a3f2" }}
            href="https://policies.google.com/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("registration.GoogleLink2")}
          </Link>
          {t("registration.GoogleText3")}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default GoogleReCaptchaText;
